<template>
	<div class="leftres">
		<div>
			<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
				<div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist :options="item.options" ref="select" :inputdata="item.inputdata"
						:lablewith="item.lablewith" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width"></Commondropdownlist>
				</div>
				<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
					<CommonBtngroup :show="showorhide" @showclick="showclick" @hide="hide" @select="selectmenuper"
						@reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>
			<div class="TableBox"
				style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px;background-color: #FFFFFF;">
				<Systemtable @Export="Export" :tableData="tableData" :total="total"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></Systemtable>
			</div>
			<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK"
				:src="'../assets/icon/icon-errors.png'">
				<span
					style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
			</Dialog>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Systemtable from '../components/systemtable.vue'
	import Dialog from '../../../components/dialog.vue'
	import {
		UserInfoList,
		UserInfoExport,
		RolesList,
		InventoryClassList
	} from '@/api/home'
	import utils from '../../../common/utils'
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Systemtable,
			Dialog,

		},
		data() {
			return {
				dialogVisibles: false,
				showorhide: true,
				tableData: [],
				total: 1,
				pageindex: 1,
				pageSize: 20,
				userName: '',
				trueName: '',
				enabled: '',
				isOperator: '',
				createTime1: "",
				createTime2: "",
				InvClass: "",
				RID: '',
				formdata: [{
						inputdata: '',
						title: '用户名',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '220px'
					},
					{
						inputdata: '',
						title: '姓名',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '220px',
						lablewith: '100px',
					},
					{
						inputdata: '',
						title: '是否可用',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '220px',
						options: [{
							value: '全部',
							key: null
						}, {
							value: '启用',
							key: '1'
						}, {
							value: '停用',
							key: '0'
						}, ],
						lablewith: '100px',
					},
					{
						inputdata: '',
						title: '是否操作员',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '230px',
						options: [{
							value: '全部',
							key: null
						}, {
							value: '是',
							key: '1'
						}, {
							value: '否',
							key: '0'
						}, ],
						lablewith: '100px',
					},
					{
						inputdata: "",
						title: "创建日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
						lablewith: '78px'
					},
					{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '220px',
						options: [],
						lablewith: '100px',
					}, {
						inputdata: '',
						title: '角色筛选',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '220px',
						options: [],
						lablewith: '100px',
					}
				]
			}
		},
		created() {
			// //console.log(this.$route.query.NodeID, "Nodessssssssssssssss")

		},
		mounted() {
			this.userInfoList()
			this.inventoryClassList()
			this.getRolesList();
			// //console.log(this.$route.query.NodeID, "Nodessssssssssssssss")
		},
		methods: {
			// 查询用户列表
			async userInfoList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				// this.formdata[0].inputdata = this.roleName
				let {
					code,
					data,
					message
				} = await UserInfoList({
					RID: this.RID,
					userName: this.userName,
					trueName: this.trueName,
					inActive: this.enabled,
					isOperator: this.isOperator,
					createTime1: this.createTime1,
					createTime2: this.createTime2,
					InvClass: this.InvClass,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (code == 0) {
					this.total = data.count
					this.tableData = data.data
				} else {
					this.$message.error(message)
				}
				loading.close();
			},
			// 导出
			async userInfoExport() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await UserInfoExport({
					RID: this.RID,
					userName: this.userName,
					trueName: this.trueName,
					inActive: this.enabled,
					isOperator: this.isOperator,
					createTime1: this.createTime1,
					createTime2: this.createTime2,
					InvClass: this.InvClass,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `用户管理${str}`, "xlsx")
					loading.close();
				} else {
					// 返回json
					this.$message.warning('导出失败');
					loading.close();
				}
				loading.close()
			},
			Export() {
				this.userInfoExport()
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({});
				if (code == 0) {
					this.formdata[5].options = [];
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName,
						};
						this.formdata[5].options.push(obj);
					});
				}
			},
			//获取角色列表
			async getRolesList() {
				let {
					code,
					data
				} = await RolesList({});
				if (code == 0) {
					this.formdata[6].options = [];
					data.data.map((item, index) => {
						let obj = {
							key: item.RID,
							value: item.RoleName,
						};
						this.formdata[6].options.push(obj);
					});
				}
			},
			// 重置文本框
			reset() {
				this.$refs.select.map((item, index) => {
					if (index == 4) {
						item.startTime = ''
						item.endTime = ''
					}
					item.modelvalue = ''
				})
				// this.dialogVisibles = true
			},
			cancel() {
				this.dialogVisibles = false
			},
			// 搜索
			selectmenuper() {
				this.pageindex = 1
				let e = this.$refs.select
				try {
					this.userName = e[0].modelvalue
					this.trueName = e[1].modelvalue
					this.enabled = e[2].modelvalue == "全部" ? "" : e[2].modelvalue
					this.isOperator = e[3].modelvalue == "全部" ? "" : e[3].modelvalue
					this.createTime1 = e[4].startTime
					this.createTime2 = e[4].endTime
					this.InvClass = e[5].modelvalue
					this.RID = e[6].modelvalue
					this.userInfoList()
				} catch (error) {
					this.userInfoList()
				}
			},
			dialogOK() {
				// //console.log('name2')
				this.dialogVisibles = false
			},
			hide() {
				this.showorhide = false
				// //console.log("askdas", this.showorhide)

			},
			showclick() {
				this.showorhide = true
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.userInfoList()
				//console.log(pageindex, 'pageindex')

			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.userInfoList()

			},
		}
	}
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 50px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all 0.3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 350px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 45px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 20px;
	}
</style>
